
const Constant = {

    app_name: "Afta Wallet Dashboard",

    speed_limit_points: "speed_limit_points",
    transportation_mode: "transport_modes",
    countries: "countries",
    trip_sign_data: "trip_sign_data",
    trip_sign_data_new: "trip_sign_data",
    routes: "routes",
    cities: "cities",
    sign_data: "sign_data",
    pk_data: "pk_data",
    trips: "trips",
    incidents: "incidents",
    settings: "settings",
    interest: "interests",
    reward_settings: "reward_settings",
    broadcast_notifications: "broadcast_notifications",

    storage_path: {
        transportation_mode: "transportMode",
        trip_sign_data: "tripSignData"
    },

    id: {
        file_import_excel_id: "excel-file-import",
        file_import_img_id: "image-file-import-tm",
        file_import_tsd_img_id: "image-file-import-tsd",
        file_import_sd_img_id: "image-file-import-sd",
        file_import_excell_pays: "excel-file-import-pays",
        file_import_excell_ville: "excel-file-import-ville",
        file_import_excell_sign: "excel-file-import-sign",
        file_import_excell_route: "excel-file-import-route",
        file_import_excell_trip: "excel-file-import-trip",
        file_import_excell_pk_data: "excel-file-import-pk-data",
    },
    spinner_color: "#eee",
    google_api_key: "AIzaSyDvM9WQhHIYzicpcuJR3AqsF97pnZ1y2gg",
    endpoints: {
        import_excel_slp: "https://us-central1-freemove-c3a47.cloudfunctions.net/importExcelSpeedLimit",
        import_excel_countries: "https://us-central1-freemove-c3a47.cloudfunctions.net/importCountries",
        import_excel_routes: "https://us-central1-freemove-c3a47.cloudfunctions.net/importExcelRoutes",
        import_excel_cities: "https://us-central1-freemove-c3a47.cloudfunctions.net/importExcelCities",
        import_excel_sign: "https://us-central1-freemove-c3a47.cloudfunctions.net/importExcelSigndata",
        import_excel_trip: "https://us-central1-freemove-c3a47.cloudfunctions.net/importExcelTripSignData",
        import_excel_pk_data: "https://us-central1-freemove-c3a47.cloudfunctions.net/importExcelPkdata",
        post_speed_limit_point: "https://us-central1-freemove-c3a47.cloudfunctions.net/addSpeedLimit",
        post_country: "https://us-central1-freemove-c3a47.cloudfunctions.net/addUpdateCountry",
        post_city: "https://us-central1-freemove-c3a47.cloudfunctions.net/addCity",
        post_route: "https://us-central1-freemove-c3a47.cloudfunctions.net/addRoute",
        post_pk_data: "https://us-central1-freemove-c3a47.cloudfunctions.net/addPkdata",
        post_sign_info: "https://us-central1-freemove-c3a47.cloudfunctions.net/addSigndata",
        post_trip_sign_info: "https://us-central1-freemove-c3a47.cloudfunctions.net/addTripSignData",
    },
    proximity: .500,
    incident_types: {
        bad_road: "bad_road",
        road_blocked: "road_blocked",
        accident: "accident",
        road_under_construction: "road_under_construction",
        traffic: "traffic"
    },
    incident_types_images: {
        bad_road: "https://firebasestorage.googleapis.com/v0/b/freemove-c3a47.appspot.com/o/incidentTypes%2Ffreemove_broken_road.png?alt=media&token=c8df1e2b-b9b1-4ed7-a849-229e7793af86",
        road_blocked: "https://firebasestorage.googleapis.com/v0/b/freemove-c3a47.appspot.com/o/incidentTypes%2Ffreemove_blocked_road.png?alt=media&token=aeadd942-cded-4757-841c-254857ec92af",
        accident: "https://firebasestorage.googleapis.com/v0/b/freemove-c3a47.appspot.com/o/incidentTypes%2Ffreemove_crash.png?alt=media&token=04482600-c5db-493a-b1b2-4e7888382a66",
        road_under_construction: "https://firebasestorage.googleapis.com/v0/b/freemove-c3a47.appspot.com/o/incidentTypes%2Ffreemove_works.png?alt=media&token=9a15e35a-a644-4781-8783-bc9b2303d0d0",
        traffic: "https://firebasestorage.googleapis.com/v0/b/freemove-c3a47.appspot.com/o/incidentTypes%2Ffreemove_traffic.png?alt=media&token=c4fc0225-98b4-4c5b-853d-82d60720edb5"
    },
    incident_types_labels: {
        bad_road: {
            en: "Bad road",
            fr: "Mauvaise route"
        },
        road_blocked: {
            en: "Road blocked",
            fr: "Route barrée"
        },
        accident: {
            en: "Accident",
            fr: "Accident"
        },
        road_under_construction: {
            en: "Road under construction",
            fr: "Route en construction"
        },
        traffic: {
            en: "Traffic",
            fr: "Embouteillage"
        }
    }
};

export default Constant;